export default __webpack_public_path__ + "static/media/enghien30.632bf1d7.jpg";